<template>
  <div id="app">
    <div class="main-wrapper">
      <router-view />
    </div>
    <app-footer v-if="showFooter" />
  </div>
</template>

<script>
import AppFooter from "@/components/layout/AppFooter.vue";

export default {
  components: {
    AppFooter,
  },
  computed: {
    showFooter() {
      const hiddenRoutes = ["/", "/signup"];
      return !hiddenRoutes.includes(this.$route.path);
    },
  },
};
</script>

<style scoped>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f6fa;
}

.main-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
</style>
